import { PricePlanTypeEnum } from 'common/enums/PricePlanTypeEnum'
import { TaxBehaviorEnum } from 'common/enums/PricingEnum'
import { OneShotPlan } from 'common/types/OfferInterface'
import { useManagement, usePayment } from 'publisher/store'
import managementSelectors from 'publisher/store/management/managementSelectors'
import {
  getCheckedPricePlanId,
  getPricePlans,
} from 'publisher/store/payment/paymentSelectors'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { TypedTFunctionInterface } from 'src/shared/i18next/types/typed-t-function-interface'

const getPricePlanExample = (t: TypedTFunctionInterface): OneShotPlan => ({
  id: 1,
  name: t('entities.offer_price.stub.name'),
  currency: 'eur',
  type: PricePlanTypeEnum.OneShot,
  taxBehavior: TaxBehaviorEnum.Exclusive,
  directChargeAmount: 4750,
})

export const useCalculatedPricePlans = () => {
  const { t } = useTypedTranslation()
  const pricePlans = usePayment(getPricePlans)
  const activePlanId = usePayment(getCheckedPricePlanId)
  const isScreenshotMode = useManagement(managementSelectors.isScreenshotMode)

  if (isScreenshotMode) {
    const pricePlanExample = getPricePlanExample(t)
    return { pricePlans: [pricePlanExample], activePlanId: pricePlanExample.id }
  }

  return { pricePlans, activePlanId }
}
